import { useState } from "react";
import { connect } from "react-redux";
import "./Home.scss";

// prop-types
import PropTypes from "prop-types";
import userPropTypes from "../../propTypes/userPropTypes";

// routes
import Routes from "../../constants/Routes";

// components
import { buildUrl } from "../../coraWebComponents/utils/helper";
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Dialog from "../../coraWebComponents/dialogs/Dialog";
import ManualPDF from "../../coraWebComponents/navigation/ManualPDF";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as filesActions from "../../actions/filesActions";


const Home = (props) => {
  const [isUserManualDialogOpen, setIsUserManualDialogOpen] = useState(false);
  const [isAdminManualDialogOpen, setIsAdminManualDialogOpen] = useState(false);

  const { isAdmin } = props;
  const pathToAssets = "assets/";
  const cardPodaZiadost = {
    altImage: "podatZiadost",
    cardTitle: "Podať žiadosť",
    cssClasses: "zmluvy",
    imgSrc: buildUrl(pathToAssets + "zis_portal_dash_zmluvy.svg"),
    route: "/podatZiadost",
    title: "Podať žiadosť",
  };
  const cardMojeZiadosti = {
    altImage: "mojeZiadosti",
    cardTitle: "Moje žiadosti",
    cssClasses: "uhrady",
    imgSrc: buildUrl(pathToAssets + "zis_portal_dash_uhrady.svg"),
    route: "/mojeZiadosti",
    title: "Moje žiadosti",
  };
  const cardMojeUlohy = {
    altImage: "mojeUlohy",
    cardTitle: "Moje úlohy",
    cssClasses: "faktury",
    imgSrc: buildUrl(pathToAssets + "zis_portal_dash_faktury.svg"),
    route: "/mojeUlohy",
    title: "Moje úlohy",
  };
  const cardVsetkyZiadosti = {
    altImage: "vsetkyZiadosti",
    cardTitle: "Všetky žiadosti",
    cssClasses: "spotreba",
    imgSrc: buildUrl(pathToAssets + "zis_portal_dash_spotreba.svg"),
    route: "/vsetkyZiadosti",
    title: "Všetky žiadosti",
  };

  const rows = isAdmin
    ? [
      { cards: [cardPodaZiadost, cardMojeZiadosti] },
      { cards: [cardMojeUlohy, cardVsetkyZiadosti] },
    ]
    : [{ cards: [cardPodaZiadost, cardMojeZiadosti] }];
  const cardsData = { rows };
  const questions = [
    `<a href="#/faq">
      <b>FAQ - Otázky a odpovede</b>.
    </a>`,
  ];

  // DIALOG METHODS
  const handleOpenUserManualDialog = () => {
    setIsUserManualDialogOpen(true);
  };

  const handleCloseUserManualDialog = () => {
    setIsUserManualDialogOpen(false);
  };

  const handleOpenAdminManualDialog = () => {
    setIsAdminManualDialogOpen(true);
  };

  const handleCloseAdminManualDialog = () => {
    setIsAdminManualDialogOpen(false);
  };


  // METHODS
  const genUserManualChildren = () => {
    const { user, getUserManual, userManualBlob, userManualFileName, isLoading } = props;

    return (
      <>
        <LoadingPanel isLoading={isLoading} />
        <ManualPDF
          manualProps={{
            hasList: false,
            user,
            manualBlob: userManualBlob,
            manualFileName: userManualFileName,
            manualTitle: "ZISPortal_prirucka",
          }}
          getManual={getUserManual}
        />
      </>
    );
  };

  const genAdminManualChildren = () => {
    const { user, getAdminManual, adminManualBlob, adminManualFileName, isLoading } = props;

    return (
      <>
        <LoadingPanel isLoading={isLoading} />
        <ManualPDF
          manualProps={{
            hasList: false,
            user,
            manualBlob: adminManualBlob,
            manualFileName: adminManualFileName,
            manualTitle: "ZISPortal_admin_prirucka",
          }}
          getManual={getAdminManual}
        />
      </>
    );
  };

  const contactZakCentrum = (e) => {
    window.location.href = "https://www.sitel.sk/sk/kontakt/";
  };

  return (
    <div className="row m-0 homeSection">
      <div className="col p-4">
        {/* Title */}
        <div className="row m-0">
          <div className="col p-0 homeTitle">
            Zákaznícky informačný portál pre odberateľov
          </div>
        </div>
        <div className="row m-0 pt-5">
          <div className="col p-0">
            Portál pre elektronické vyjadrenia k existencii telekomunikačných
            vedení a zariadení.
            <br />
            Viac informácií alebo spôsob používania portálu nájdete v{" "}
            <span onClick={handleOpenUserManualDialog} className="manual-link">
              metodických postupoch
            </span>
            .
          </div>
        </div>

        {/* BODY */}
        <div className="row m-0 pt-5">
          {/* CARDS */}
          <div className="col-sm p-0 cards-container">
            {cardsData.rows.map((row, cardRowKey) => {
              /* ITER ROWS */
              return (
                <div
                  className="row m-0 row-in-cards-container"
                  key={cardRowKey}
                >
                  {row.cards.map((card, cardKey) => {
                    /* ITER CARDS IN ROWS */
                    return (
                      <div className="col p-1" key={cardKey}>
                        <a
                          title={card.title}
                          href={`#${card.route}`}
                          className="a-card-link"
                        >
                          <div className={`card-home ${card.cssClasses}`}>
                            <img
                              className="card-content-image"
                              src={card.imgSrc}
                              alt={card.altImage}
                            />
                            <div className="card-content-text">
                              {card.cardTitle}
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
          {/* Questions */}
          <div className="col-sm p-0 questions-container">
            <div className="row m-0 questions">
              <div className="col">
                <ul className="home">
                  {questions.map((q, qKey) => {
                    return (
                      <li
                        key={qKey}
                        className="question"
                        dangerouslySetInnerHTML={{ __html: q }}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0 pt-5">
          <div className="col p-0">Vážený používateľ ZIS portálu spoločnosti SITEL s.r.o.!<br />
            Všetky služby spojené s vyjadrením a vytýčením inžinierskych sietí EKS v správe a majetku
            spoločnosti SITEL s.r.o. sú spoplatené.<br />
            <br />
            <strong>
              Výzva na zaplatenie poplatku bude vygenerovaná a zaslaná na vašu mailovú adresu.<br />
              Žiadosť sa začne vybavovať po pripísaní sumy poplatku na účet spoločnosti SITEL s.r.o.<br />
              Za úplnosť a správnosť údajov zodpovedá žiadateľ.<br />
            </strong>
            <br />
            Aktuálny cenník našich služieb nájdete na webovej stránke <a href="https://www.sitel.sk/sk/cennik/">www.sitel.sk/sk/cennik</a>.<br />
            {isAdmin && (<span><span className="manual-link" onClick={handleOpenAdminManualDialog}>Príručka</span> pre administrátorov portálu.</span>)}
          </div>
        </div>

        {/* FOOTER */}
        <div className="row m-0 pt-2 homeFooter">
          <div className="col-sm p-0 homeFooterText">
            <span>Nenašli ste odpoveď na vaše otázky?</span>
          </div>
          <div className="col-sm p-2 homeFooterButton">
            <Button
              label="Kontaktujte zákaznícke centrum"
              className="homeContactButton"
              onClick={contactZakCentrum}
            />
          </div>
        </div>
      </div>

      {/* METODICKE POSTUPY */}
      <Dialog
        isOpen={isUserManualDialogOpen}
        title={"Používateľská príručka"}
        onClose={handleCloseUserManualDialog}
        onConfirm={handleOpenUserManualDialog}
        fullscreen={true}
        className={"fullscreen-report"}
        children={genUserManualChildren()}
      />
      <LoadingPanel isLoading={props.isLoading} />

      {/* ADMIN PRIRUCKA DIALOG */}
      <Dialog
        isOpen={isAdminManualDialogOpen}
        title={"Príručka pre administrátorov"}
        onClose={handleCloseAdminManualDialog}
        onConfirm={handleOpenAdminManualDialog}
        fullscreen={true}
        className={"fullscreen-report"}
        children={genAdminManualChildren()}
      />
      <LoadingPanel isLoading={props.isLoading} />
    </div>
  );
}


const mapStateToProps = (state) => {
  return {
    isLoading: state.files.isLoading,
    userManualBlob: state.files.userManual?.blob || null,
    userManualFileName: state.files.userManual?.fileName || "ZISPortal_prirucka.pdf",
    adminManualBlob: state.files.adminManual?.blob || null,
    adminManualFileName: state.files.adminManual?.fileName || "ZISPortal_admin_prirucka.pdf",
    isAdmin: state.user.data.Uzivatel.L_ADMIN,
    user: state.user.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUserManual: () => dispatch(filesActions.getUserManual()),
  getAdminManual: () => dispatch(filesActions.getAdminManual()),
});

Home.propTypes = {
  isAdmin: PropTypes.bool,
  getUserManual: PropTypes.func,
  isLoading: PropTypes.bool,
  userManualBlob: PropTypes.object,
  userManualFileName: PropTypes.string,
  adminManualBlob: PropTypes.object,
  adminManualFileName: PropTypes.string,
  user: userPropTypes.user,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
